const UiRender = ({ color, text, icon }) => {
  return (
    <span style={{ color: color }} className="status-render">
      {icon && <i className={"mr-2 fa-solid " + icon}></i>}
      <p>{text}</p>
    </span>
  );
};

export const ZipExportStatusRender = ({ value }) => {
  switch (value) {
    case "ready":
      return <UiRender color={"#37A353"} text={"Ready"} icon={"fa-circle"} />;
    case "generating":
      return (
        <UiRender color={"#f5e642"} text={"Generating..."} icon={"fa-circle"} />
      );
    case "no_photos":
      return (
        <UiRender color={"#FF0000"} text={"No User-Uploaded Photos"} icon={"fa-circle"} />
      );
    case "not_requested":
    default:
      return (
        <UiRender color={"#888888"} text={"Not Generated"} icon={"fa-circle"} />
      );
  }
};

export const EventStatusRender = ({ value }) => {
  switch (value.toString().toLowerCase()) {
    case "past":
      return <UiRender color={"#FF0000"} text={"Past"} icon={"fa-circle"} />;
    case "upcoming":
      return (
        <UiRender color={"#f5e642"} text={"Upcoming"} icon={"fa-circle"} />
      );
    case "ongoing":
      return <UiRender color={"#37A353"} text={"Ongoing"} icon={"fa-circle"} />;
    case "deleted":
      return <UiRender color={"#FF0000"} text={"Deleted"} icon={"fa-circle"} />;
    default:
      return (
        <UiRender color={"#f5e642"} text={"Upcoming"} icon={"fa-circle"} />
      );
  }
};
